<template>
  <b-modal id="subdivisionOperationsModal"
           size="m"
           :hideFooter="true"
           centered
  >
    <template #modal-title>
      <h5 v-if="isAddModal">
        <em class="fas fa-plus send-icon"></em> Создание подразделения
      </h5>
      <h5 v-else>
        <em class="fas fa-edit"></em> Редактирование подразделения
      </h5>
    </template>
    <template #default>
      <b-form @submit.prevent="onSubmit">
        <b-form-group label-for="title_input"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      description='Пример: ПАО «Газпром»'
        >
          <template v-slot:label>
            Название: <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="title_input"
            v-model="form.title"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Сайт: "
                      label-for="site_input"
                      label-cols-sm="4"
                      label-cols-lg="3"
        >
          <b-form-input
            v-model="form.siteUrl"
            type="url"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Город: "
                      label-for="site_input"
                      label-cols-sm="4"
                      label-cols-lg="3"
        >
          <b-form-input
            v-model="form.city"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary" style="float: right">
          <div v-if="isAddModal"><em class="fas fa-plus send-icon mr-1"></em> Добавить</div>
          <div v-else><em class="fas fa-save"></em> Сохранить</div>
        </b-button>
      </b-form>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import organizationApi from '@/api/organization'

export default {
  name: 'SubdivisionOperationsModal',
  data() {
    return {
      form: {
        title: '',
        siteUrl: '',
        city: ''
      },
      id: null
    }
  },
  props: {
    isAddModal: {
      type: Boolean,
      default() {
        return true
      }
    },
    chosenSubdivision: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    chosenSubdivision(newVal) {
      if (newVal) {
        this.form.title = newVal.title
        this.form.siteUrl = newVal.siteUrl
        this.id = newVal.id
        this.form.city = newVal.city
      } else {
        this.form = {
          title: '',
          siteUrl: '',
          city: ''
        }
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.isAddModal) {
        organizationApi.addSubdivision(this.form)
          .then(() => {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Подразделение успешно создано.'
            })
            this.$bvModal.hide('subdivisionOperationsModal')
            this.$emit('subdivisionOperationCompleted')
          })
          .catch(() => {
            this.pushToasts({
              title: 'Уведомление',
              error: true,
              message: 'Ошибка создания подразделения. '
            })
          })
      } else {
        organizationApi.editOrganization({
          id: this.id,
          title: this.form.title,
          siteUrl: this.form.siteUrl,
          city: this.form.city
        })
          .then(() => {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Подразделение успешно отредактировано.'
            })
            this.$bvModal.hide('subdivisionOperationsModal')
            this.$emit('subdivisionOperationCompleted')
          })
          .catch(() => {
            this.pushToasts({
              title: 'Уведомление',
              error: true,
              message: 'Ошибка редактирования подразделения. '
            })
          })
      }
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  }
}
</script>

<style scoped>
textarea:focus,
textarea:not(focus),
textarea:active {
  outline: none !important;
  box-shadow: none !important;
  border: 1px lightgrey solid !important;
}
</style>
